import { useParams } from "react-router-dom";
import HOC from "../../../components/HOC";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import AddDoctorAnalysis from "../../../components/screen/patientCare/patientCareDoctorAnalysis/AddDoctorAnalysis";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";

const AddDoctorAnalysisPage = ({ isDetail }) => {
  const { id } = useParams();
  return (
    <PageTemplate
      header={`${id ? (isDetail ? "Detail" : "Edit") : "Add"} Doctor Analysis`}
      mainComponent={
        <ThemeProvider theme={theme}>
          <AddDoctorAnalysis isDetail={isDetail} />
        </ThemeProvider>
      }
      pageRole={19}
    />
  );
};

export default HOC(AddDoctorAnalysisPage);
